import { Modal } from 'layout/Modal'
import { useAppSelector } from 'state/hooks'
import {
  selectTxError,
  selectTxSuccess,
  setTxErrorState,
  setTxSuccessState
} from 'state/slices/ui/transaction'
import { closeForm, selectActiveBroker, selectFormOpen } from 'state/slices/ui/form'
import TxForm from 'components/txForm/TxForm'
import { selectFormattedPositions } from 'state/slices/user/portfolio'
import { selectPortfolioLoaded } from 'state/slices/user/portfolio'
import { isEmptyOrNil } from 'toolbox/account'
import TransferSuccess from 'components/txForm/TransferSuccess'
import { ErrorModal } from 'components/wallet/ErrorModal'
import { closeBlock, selectShowBlockModal } from 'state/slices/ui/dash'
import { BlockedModal } from './BlockedModal'

export function AppModals() {
  const positions = useAppSelector(selectFormattedPositions)
  const isLoadedUser = useAppSelector(selectPortfolioLoaded)
  const isFormOpen = useAppSelector(selectFormOpen)
  const formBroker = useAppSelector(selectActiveBroker)
  const txSuccessState = useAppSelector(selectTxSuccess)
  const txSuccessOpen = !isEmptyOrNil(txSuccessState)
  const txError = useAppSelector(selectTxError)
  const isErrorOpen = !isEmptyOrNil(txError)
  const showBlockModal = useAppSelector(selectShowBlockModal)
  return (
    <>
      <Modal open={isFormOpen} onClose={closeForm} transition={'bot-up'}>
        <TxForm broker={formBroker} isLoadedUser={isLoadedUser} positions={positions} />
      </Modal>
      <Modal open={txSuccessOpen} onClose={() => setTxSuccessState(null)} transition={'bot-up'}>
        <TransferSuccess />
      </Modal>
      <Modal open={isErrorOpen} onClose={() => setTxErrorState(null)} transition={'bot-up'}>
        <ErrorModal {...txError} />
      </Modal>
      <Modal open={showBlockModal} onClose={closeBlock} transition={'top-down'}>
        <BlockedModal />
      </Modal>
    </>
  )
}
